module.exports = __webpack_public_path__ + "img/ontwerp_appartementencomplex-01.d0031dc0.jpg";